@if (show) {
  <primecontrol-progress-bar [mode]="mode" [value]="progress"></primecontrol-progress-bar>
}
